import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/vimeo': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M403.2 32c24.7 0 44.8 20.1 44.8 44.8v358.4c0 24.7-20.1 44.8-44.8 44.8h-358.4c-24.7 0-44.8-20.1-44.8-44.8v-358.4c0-24.7 20.1-44.8 44.8-44.8h358.4zM377 180.8c1.9-42.2-13.8-63.8-47.1-64.7-44.9-1.4-75.3 23.9-91.2 76 19.9-8.5 49.3-10.8 45.8 22.4-1 11.2-8.3 27.5-21.8 48.9-37.7 59.4-46.9 39.6-67.6-91.6-5.8-36.9-21.3-54.1-46.5-51.7-22.3 2-57.9 38.4-95.2 71.2l15.2 19.6c14.5-10.1 23-15.2 25.4-15.2 21 0 31.9 54.7 57.4 148 13.1 34.9 29 52.3 47.9 52.3 30.4 0 67.7-28.6 111.7-85.8 42.6-54.7 64.6-97.9 66-129.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/vimeo.js
// module id = 1079
// module chunks = 0